import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HistoryListComponent } from '@shared/components/history-list/history-list.component';
import { EmployeeTransactionHistoryResponse } from '../../employee.model';

@Component({
  selector: 'employee-history',
  imports: [HistoryListComponent],
  templateUrl: './employee-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmployeeHistoryComponent {
  readonly history = input<EmployeeTransactionHistoryResponse[]>([]);
}
